<template>
  <video
    ref="video"
    playsinline
    autoplay
    muted
    loop />
</template>
<script lang="ts" setup>
const video = ref()
const props = defineProps<{
  src: string
}>()

onMounted(async () => {
  await nextTick()
  if (video.value.canPlayType('application/vnd.apple.mpegurl')) {
    video.value.src = props.src
    video.value.play()
  } else {
    const { default: Hls } = await import('hls.js/light')
    const hls = new Hls()
    hls.loadSource(props.src)
    hls.attachMedia(video.value)

    let previousFrag = null
    hls.on(Hls.Events.FRAG_CHANGED, (_event, data) => {
      // When current framgent quality level is greater then the previous one, then it
      // means that the previous is loaded on a lower level.
      // So we flush the buffer of the video from start to the end of the previous fragment.
      if (data.frag.level > previousFrag?.level) {
        hls.trigger(Hls.Events.BUFFER_FLUSHING, {
          startOffset: previousFrag.start,
          endOffset: previousFrag.end - 0.1
        })
      }

      previousFrag = data.frag
    })
  }

  video.value.addEventListener('pause', () => {
    video.value.play()
  })
})

onActivated(() => video.value.play())
</script>
